(() => {
  // ---- helpers ----
  const safeParse = (json, fallback) => { try { return JSON.parse(json); } catch { return fallback; } };
  const fmt = (cents, currency) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((cents || 0) / 100);

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  };

  // resolve currencies
  const getBaseCurrency = () =>
    document.documentElement.getAttribute('data-shop-currency') ||
    (window.Shopify && Shopify.currency && Shopify.currency.shopCurrency) ||
    'USD';

  const getActiveCurrency = (cart) =>
    (cart && cart.currency) ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    getBaseCurrency();

  // conversion rate: base -> active
  const getRate = (active, base) => {
    if (!active || !base || active === base) return 1;
    if (window.Shopify && Shopify.currency && typeof Shopify.currency.rate === 'number') {
      return Shopify.currency.rate || 1;
    }
    // No rate available; use 1:1
    console.debug('[Tier Motivator] No Shopify.currency.rate; using 1:1. Enable currency snippet for live conversion.');
    return 1;
  };

  const render = (root, cart) => {
    const baseCurrency   = getBaseCurrency();
    const activeCurrency = getActiveCurrency(cart);

    // tiers are in BASE currency; auto-convert using rate
    const rawTiers = safeParse(root.dataset.tiers || '[]', []);
    const rate = getRate(activeCurrency, baseCurrency);

    // support array shape (recommended); if object, try base key
    const tiersArray = Array.isArray(rawTiers) ? rawTiers : (rawTiers[baseCurrency] || []);
    const tiers = tiersArray
      .map(t => ({
        threshold: Number(t.threshold) * rate,
        savings:   Number(t.savings)   * rate
      }))
      .filter(t => !isNaN(t.threshold) && !isNaN(t.savings))
      .sort((a,b) => a.threshold - b.threshold);

    const colors = safeParse(root.dataset.colors || '[]', []);
    const fill = root.querySelector('.tier-motivator__fill');
    const text = root.querySelector('.tier-motivator__text');

// dynamic exclusions (handles or SKUs, comma-separated from settings)
const excludedList = (root.dataset.excluded || '')
  .split(',')
  .map(s => s.trim().toLowerCase())
  .filter(Boolean);

const validItems = Array.isArray(cart.items) ? cart.items.filter(it => {
  const h = (it.handle || '').toLowerCase();
  const s = (it.sku || '').toLowerCase();
  // exclude if either matches any entry
  return !(excludedList.includes(h) || (s && excludedList.includes(s)));
}) : [];

const subtotalCents = validItems.reduce((s, it) => s + (it.original_line_price ?? it.final_line_price ?? 0), 0);
const subtotal = subtotalCents / 100;

    // current + next tier
    let currentIdx = -1, next = null;
    for (let i=0;i<tiers.length;i++){
      if (subtotal >= tiers[i].threshold) currentIdx = i;
      if (subtotal < tiers[i].threshold && !next) next = tiers[i];
    }

    // color cycle
    const activeColor = colors[(currentIdx + 1) % (colors.length || 1)] || '#4CAF50';
    fill.style.backgroundColor = activeColor;

    if (next) {
      const lower = currentIdx >= 0 ? tiers[currentIdx].threshold : 0;
      const span = Math.max(0.01, next.threshold - lower);
      const progress = Math.max(0, Math.min(1, (subtotal - lower) / span));
      fill.style.width = (progress * 100) + '%';

      const remaining = Math.max(0, next.threshold - subtotal);
      if (currentIdx >= 0) {
        const cur = tiers[currentIdx];
        text.innerHTML =
          `YOU HAVE <strong>${fmt(cur.savings*100, activeCurrency)}</strong> OFF AT CHECKOUT<br>` +
          `ADD <strong>${fmt(remaining*100, activeCurrency)}</strong> TO SAVE ` +
          `<strong>${fmt(next.savings*100, activeCurrency)}</strong>.`;
      } else {
        text.innerHTML =
          `ADD <strong>${fmt(remaining*100, activeCurrency)}</strong> TO SAVE ` +
          `<strong>${fmt(next.savings*100, activeCurrency)}</strong> OFF.`;
      }
    } 
    else if (tiers.length) {
      fill.style.width = '100%';
      const top = tiers[tiers.length-1];
      text.innerHTML = `  NICE! YOU’VE QUEALIFIED FOR <strong>${fmt(top.savings*100, activeCurrency)}</strong> OFF AT CHECKOUT .`;
    } 
    else {
      fill.style.width = '0%';
      text.textContent = 'Add items to unlock savings.';
    }
  };

  // debounce refresh
  let t;
  const refresh = async () => {
    clearTimeout(t);
    t = setTimeout(async () => {
      try {
        const cart = await fetchCart();
        document.querySelectorAll('.tier-motivator').forEach(el => render(el, cart));
      } catch(e) { /* noop */ }
    }, 80);
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('vinyl:cart:changed', refresh);
})();
